import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Top from '../views/Top.vue'
import HowToUse from '../views/HowToUse.vue'
import HowToUseHeader from '../views/HowToUseHeader.vue'
import HowToUseMobile from '../views/HowToUseMobile.vue'
import List from '../views/List.vue'

Vue.use(VueRouter)

const routes = [
/*
  {
    path: '/',
    name: 'home',
    component: Home
  },
*/
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/',
    name: 'top',
    component: Top
  },
  {
    path: '/list',
    name: 'list',
    component: List
  }
]

const router = new VueRouter({
//  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
